import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../../wui-icon/src';
import {prefix, WebUI} from "../../wui-core/src/index"
import { ModalHeaderProps } from './iModal';


// const propTypes = {

//     /**
// 	 * 是否显示关闭按钮
// 	 */
//     closeButton: PropTypes.bool,
//     /**
// 	 * 自定义关闭按钮的钩子函数
// 	 */
//     renderCloseButton: PropTypes.func,
//     /**
//      * 自定义全屏按钮的钩子函数
//      */
//     renderMaximizeButton: PropTypes.func,
//     /**
// 	 * 自定义关闭按钮的 props
// 	 */
//     closeButtonProps: PropTypes.object,
//     onMaximize: PropTypes.func,
//     maximize: PropTypes.oneOfType([PropTypes.element, PropTypes.bool]),
//     'aria-label': PropTypes.string,
//     fieldid: PropTypes.string,
// };

const defaultProps = {
    'aria-label': 'Close',
    closeButton: false,
    clsPrefix: `${prefix}-modal-header`
};

const contextTypes = {
    $modal: PropTypes.shape({
        onCancel: PropTypes.func,
        handleHide: PropTypes.func,
        handleMaximize: PropTypes.func,
        isMaximize: PropTypes.func,
    }),
};

@WebUI({name: "modal-header", defaultProps})
class ModalHeader extends React.Component<ModalHeaderProps> {
    static defaultProps = defaultProps;
    static contextTypes = contextTypes;
	// 点击右上角关闭
	_onCancelClick = async() => {
	    const modal = this.context && this.context.$modal;
	    if (!modal) {
	        return
	    }
	    modal.onCancel();
	}
	_onMaximize = () => {
	    const modal = this.context && this.context.$modal;
	    if (!modal) {
	        return
	    }
	    const isMaximize = modal.isMaximize();
	    modal.handleMaximize(!isMaximize);// 只处理放大缩小状态，不再处理是否显示最大化图标和最大化dom
	}

	render() {
	    const {
	        'aria-label': label,
	        /* eslint-disable */
            renderMaximizeButton,
	        closeButton,
	        className,
            draggable,
	        clsPrefix,
	        children,
	        renderCloseButton,
	        closeButtonProps,
	        /* eslint-disable */
	        onMaximize,
            fieldid,
            id,
            dragCtrlId,
	        maximize,
	        ...props
	    } = this.props;

	    let isMaximize = false;
	    const modal = this.context?.$modal;
	    if (modal) {
	        isMaximize = modal.isMaximize();
	    }
	    const classes: {[key: string]: boolean} = {};
	    classes[`${clsPrefix}`] = true;
	    classes[`${clsPrefix}-dnd-handle`] = !!draggable;
	    classes[`${clsPrefix}-handle-${dragCtrlId}`] = !!draggable;

    const closeBtnDom = (
      <button
        {...closeButtonProps}
        type="button"
        className="close dnd-cancel"
        fieldid={fieldid ? `${fieldid}_close` : undefined}
        // 原测试脚本 id规范
        id={id ? `modalkey_${id}close` : undefined}
        aria-label={label}
        onClick={this._onCancelClick}
      >
        {renderCloseButton ? renderCloseButton() :
            <Icon aria-hidden="true" type='uf-close'/>
        }
      </button>
    )
    const maximizButton = maximize ? (
        <button
        {...closeButtonProps}
        type="button"
        className="close maximize"
        fieldid={fieldid ? isMaximize ? `${fieldid}_max` : `${fieldid}_min` : undefined}
        onClick={this._onMaximize}
      >
        {renderMaximizeButton ? renderMaximizeButton(isMaximize) :
            <Icon className="maximize-icon" type={isMaximize ?'uf-zuixiaohua' : 'uf-zuidahua'}/> }
      </button>
    ) : null;
    return (
      <div
        fieldid={fieldid}
        {...props}
        className={classNames(className, classes)}
      >
            {closeButton && closeBtnDom}
            {maximizButton && maximizButton}
            {children}
	        </div>
	    );
	}
}

// ModalHeader.propTypes = propTypes;
ModalHeader.contextTypes = contextTypes;

export default ModalHeader as React.ComponentClass<Partial<ModalHeaderProps>>;
